import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  center: {
    textAlign: "center",
  },
  heading: {
    fontWeight: 600,
  },
  item: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  image: {
    display: "flex",
    justifyContent: "center",
  },
};
